module.exports = __webpack_public_path__ + "static/media/irp.87d36837.png";